/**
 * EmployeeFileTypeService
 * Service for EmployeeFileType entity operations
 * Route: api/employeefiletypes
 */
import { CrudService } from '../base/CrudService';
/**
 * EmployeeFileTypeService
 * Handles employee file type CRUD operations
 */
export class EmployeeFileTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EmployeeFileTypeService.DEFAULT_SERVICE_PATH,
            basePath: EmployeeFileTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EmployeeFileTypeService.DEFAULT_SERVICE_PATH = 'hr';
EmployeeFileTypeService.BASE_PATH = 'api/employeefiletypes';
//# sourceMappingURL=EmployeeFileTypeService.js.map